import React, { Component } from 'react';
import { I18n } from 'react-i18next';
import Menu from './menu';
import Footer from './footer';
import PrivacyPolicyContent from "./privacyPolicyContent";

export default class PrivacyPolicy extends Component {
    componentDidMount () {
        setTimeout(() => this.node.scrollIntoView(), 0);
    }

    render() {
        return (
            <I18n ns="translations">
                {
                    (t, {i18n}) => (
                        <div id="wraper-other" ref={node => this.node = node}>
                            <header>
                                <Menu/>
                            </header>
                            <div id="contact">
                                <PrivacyPolicyContent t={t}/>;
                            </div>
                            <Footer/>
                        </div>
                    )
                }
            </I18n>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/privacyPolicy.jsx